import React, { useEffect, useState } from 'react';
import BucketListModal from 'src/components/BucketListModal';
import useEnhanceApiClient from 'src/hooks/useEnhanceApiClient';
import { BucketListOption, Option, User } from 'src/types';
import ApiClient from 'src/lib/api_client';
import useBucketList from 'src/hooks/useBucketList';
import useCurrentUser from 'src/hooks/useCurrentUser';
import useModalLogin from 'src/hooks/useModalLogin';
import { flatten } from 'lodash-es';

const HeartButton: React.FC<{
  className?: string;
  option: Option;
  isGiftExperience?: boolean;
  bucketListOption?: BucketListOption;
  heartBlankIcon: JSX.Element;
  heartFillIcon: JSX.Element;
  onRemove?: (bucketListOption: BucketListOption) => void;
}> = ({ option, isGiftExperience, className, bucketListOption, heartBlankIcon, heartFillIcon }) => {
  const [currentUser] = useCurrentUser();
  const deleteBucketListOption = useEnhanceApiClient(ApiClient.deleteBucketListOption);
  const { mutate, setDeletedBucketListOption } = useBucketList();
  const [showModal, setShowModal] = useState(false);
  const [isTouched, setIsTouched] = useState(false)
  const { show: showModalLogin, setShow: setShowModalLogin } = useModalLogin()

  const remove = () => {
    if (bucketListOption) {
      deleteBucketListOption({
        bucketListId: bucketListOption?.bucketListId,
        id: bucketListOption.id,
      }).then((result) => {
        setDeletedBucketListOption(bucketListOption);
        mutate();
      });
    }
  };

  const create = () => {
    if (currentUser) {
      setShowModal(true);
    } else {
      setIsTouched(true);
      setShowModalLogin(true)
    }
  };

  useEffect(() => {
    if (!showModalLogin) {
      setIsTouched(false)
    }
  }, [showModalLogin])

  useEffect(() => {
    const callback = (event: CustomEvent<User>) => {
      if (!isTouched) return
      setShowModalLogin(false)
      const user = event.detail
      const bucketListOptions = flatten((user.bucketLists || []).map((o) => o.bucketListOptions || []));
      const bucketListOption = bucketListOptions.find(
        (o) => o.supplierActivityOptionId === Number(option.id) && o.isGiftExperience === isGiftExperience
      );
      if (user && option.id && !bucketListOption) {
        setShowModal(true);
      } else {
        setShowModal(false);
      }
    }
    document.addEventListener('ss:logged_in', callback, { once: true })

    return () => {
      document.removeEventListener('ss:logged_in', callback)
    }
  }, [option.id, isTouched])

  return (
    <>
      <div
        className={className}
        onClick={() => {
          bucketListOption && bucketListOption.isGiftExperience === isGiftExperience
            ? remove()
            : create();
        }}
      >
        {bucketListOption && bucketListOption.isGiftExperience === isGiftExperience
          ? heartFillIcon
          : heartBlankIcon}
      </div>
      {showModal ? (
        <BucketListModal
          option={option}
          show={showModal}
          isGiftExperience={isGiftExperience}
          onClose={() => {
            setShowModal(false);
          }}
        />
      ) : null}
    </>
  );
};

export default HeartButton;
